import { Card, CardHeader, Skeleton } from "@mui/material";
import React from "react";

const UserChatSkeleton = () => {
  const arr = [1, 2, 3, 4, 5];
  return (
    <>
      {arr.map((data) => {
        return (
          <Card sx={{ maxWidth: 345 }} key={data} className="my-3">
            <CardHeader
              avatar={
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={40}
                  height={40}
                />
              }
              title={
                <Skeleton
                  animation="wave"
                  height={10}
                  width="80%"
                  style={{ marginBottom: 6 }}
                />
              }
              subheader={<Skeleton animation="wave" height={10} width="40%" />}
            ></CardHeader>
          </Card>
        );
      })}
    </>
  );
};

export default UserChatSkeleton;
